module.exports = [{
      plugin: require('C:/Users/Ulrjch/Downloads/Compressed/gatsby-starter-infinite-scroll-master/node_modules/gatsby-plugin-colorblind-filters/gatsby-browser.js'),
      options: {"plugins":[],"zIndex":2000},
    },{
      plugin: require('C:/Users/Ulrjch/Downloads/Compressed/gatsby-starter-infinite-scroll-master/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"static/gatsby-icon.png"},
    },{
      plugin: require('C:/Users/Ulrjch/Downloads/Compressed/gatsby-starter-infinite-scroll-master/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
